import './email-content-group.scss';

import EmailContentGroup from './EmailContentGroup';

export default EmailContentGroup;
